import React, { Component } from 'react';
import PropTypes from 'prop-types';

const filterNames = {
  categories: 'Category',
  colors: 'Color',
  conditions: 'Condition',
  isPreviouslyPurchasedOnly: 'Previously Purchased Items',
  lVolumes: 'Volume (L)',
  mlVolumes: 'Volume (mL)',
  packAmounts: 'Pack Amount',
  pageYields: 'Page Yield',
  photosYields: 'Photo Yield',
  sizes: 'Size',
  staplesYields: 'Staple Yield'
};

const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});

class SearchResultsFilter extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.toggleFilter = this.toggleFilter.bind(this);

    this.state = {
      isFilterToggled: false
    };
  }

  toggleFilter() {
    this.setState({
      isFilterToggled: !this.state.isFilterToggled
    });
  }

  render() {
    const filters = this.props.filters,
      filterValues = this.props.filterValues;

    return (
      <div className="product-filters">
        <button className="button tiny -gray hide-for-medium" onClick={this.toggleFilter}>
          {
            this.state.isFilterToggled
              ? <span>&times; Hide Filters</span>
              : <span><i className="icon-bars"/> Show Filters</span>
          }
        </button>

        <div className={`product-filters__inner ${this.state.isFilterToggled ? '' : 'show-for-medium'}`}>
          <h2>Refine by</h2>
          {
            Object.keys(filters).map(filterId =>
              <div key={filterId} className="product-filters__group">
                <h3>{filterNames[filterId]}</h3>
                <ul className="product-filters__group__values">
                  {
                    Object.entries(filters[filterId]).sort(([,a], [,b]) => collator.compare(a, b)).map(([value]) =>
                      <li key={value}>
                        <label>
                          <input type="checkbox" value={value} checked={filterValues[filterId].indexOf(value) > -1}
                                 onChange={e => this.props.onChange(e.target.checked, filterId, value)} />
                          <span>{filters[filterId][value]}</span>
                        </label>
                      </li>
                    )
                  }
                </ul>
              </div>
            )
          }
        </div>
      </div>
    );
  }
}

SearchResultsFilter.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  filterValues: PropTypes.object.isRequired
};

export default SearchResultsFilter;
